import { DriverDetailsResponseItem } from "../../../api/raily/driver/details/driver-details.response";
import DriverDetails from "./driver-details";

const create = (item: DriverDetailsResponseItem): DriverDetails => {
  return {
    firstName: item.firstName,
    lastName: item.lastName,
  };
};

const driverDetailsFactory = { create };

export default driverDetailsFactory;
